import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { FC, useMemo } from 'react';

import { formatNumber } from 'src/utils/common';

import { ProductSupplierReceiptDateRow } from 'src/hooks/swr/useSWRProductSupplierReceiptDates';

const defaultColDef = {
  sortable: true,
  resizable: true,
  filter: true,
};

const columnDefs: ColDef<ProductSupplierReceiptDateRow>[] = [
  {
    headerName: 'Id',
    field: 'id',
    width: 80,
    hide: true,
  },
  {
    headerName: '입고일',
    field: 'transactionDate',
    width: 140,
  },
  {
    headerName: '매입금액',
    field: 'totalPrice',
    width: 140,
    valueFormatter: (params: ValueFormatterParams<ProductSupplierReceiptDateRow>) =>
      params.value == null ? '' : formatNumber(params.value),
  },
  {
    headerName: '특이사항',
    field: 'remarks',
    flex: 1,
    minWidth: 120,
    tooltipField: 'remarks',
  },
];

interface ProductSupplierReceiptDateTableProps {
  rowData: ProductSupplierReceiptDateRow[];
  onRowClick: (row: ProductSupplierReceiptDateRow) => void;
}

const ProductSupplierReceiptDateTable: FC<ProductSupplierReceiptDateTableProps> = ({ rowData, onRowClick }) => {
  const totalPriceSum = useMemo(() => rowData.reduce((sum, row) => sum + row.totalPrice, 0), [rowData]);
  const pinnedBottomRowData = useMemo(() => [{ transactionDate: '합계', totalPrice: totalPriceSum }], [totalPriceSum]);

  return (
    <div className='ag-theme-alpine height100'>
      <AgGridReact
        rowData={rowData}
        getRowId={(params) => params.data.id}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowSelection='single'
        // 행 선택을 켜놓더라도 개별 셀의 내용을 복사할 수 있도록한다.
        enableCellTextSelection={true}
        pinnedBottomRowData={pinnedBottomRowData}
        onSelectionChanged={(e) => {
          onRowClick(e.api.getSelectedRows()[0]);
        }}
      />
    </div>
  );
};

export default ProductSupplierReceiptDateTable;
